// Neighboring FL counties to Palm Beach:
// North: Martin, St. Lucie
// South: Broward, Miami-Dade
// West: Hendry, Glades
export const COUNTIES = [
  "Palm Beach",
  "Martin",
  "St. Lucie",
  "Broward",
  "Miami-Dade",
  "Hendry",
  "Glades",
];

export const OFFICES = ["KW Wellington", "KW Clearwater", "Other"];

export const SAMPLE_LISTINGS = [
  {
    id: "seed-1",
    address: "1253 Union Street",
    city: "Wellington",
    county: "Palm Beach",
    listPrice: 875000,
    daysOnMarket: 12,
    availableDate: "2026-02-14",
    sellerPrefTime: "12:00 PM - 3:00 PM",
    notes: "Circular driveway — signs OK at entrance. Friendly golden retriever indoors.",
    agentName: "Marcus Vega",
    agentPhone: "561-555-0142",
    agentEmail: "delivered@resend.dev",
    status: "available",
    claimedBy: null,
    postedAt: "2026-02-06T14:22:00Z",
  },
  {
    id: "seed-2",
    address: "742 Beachfront Drive",
    city: "Jupiter",
    county: "Palm Beach",
    listPrice: 1450000,
    daysOnMarket: 4,
    availableDate: "2026-02-15",
    sellerPrefTime: "1:00 PM - 4:00 PM",
    notes: "Waterfront property. Please remove shoes. Wine glasses on counter for staging — do not move.",
    agentName: "Priya Sundaram",
    agentPhone: "561-555-0187",
    agentEmail: "priya.s@kw.com",
    status: "available",
    claimedBy: null,
    postedAt: "2026-02-07T09:10:00Z",
  },
  {
    id: "seed-3",
    address: "3308 Palomino Trail",
    city: "Loxahatchee",
    county: "Palm Beach",
    listPrice: 625000,
    daysOnMarket: 21,
    availableDate: "2026-02-21",
    sellerPrefTime: "11:00 AM - 2:00 PM",
    notes: "Equestrian estate — 3 acres. Long driveway, park near barn. Bring water.",
    agentName: "Sarah Jenkins",
    agentPhone: "561-555-0119",
    agentEmail: "sarah.jenkins@kw.com",
    status: "available",
    claimedBy: null,
    postedAt: "2026-02-01T16:45:00Z",
  },
];
